export default {
  title: "Close Completed Work Order",
  content:
    "Are you sure you want to close the selected <b class='text-info'>Work Order</b>?<br><br>This <b class='text-uppercase'>cannot</b> be undone.",
  label: "Skip confirmation next time for Completed <b class='text-info'>Work Orders</b>",
}
